var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibility)?_c('el-dialog',{attrs:{"visible":true,"title":_vm.title,"append-to-body":true},on:{"close":function($event){return _vm.onCancel()}}},[_c('div',[_c('div',{attrs:{"id":"captcha-box"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }